import { forwardRef, lazy, useMemo } from 'react';
import { SvgIcon, Theme } from '@material-ui/core';

/**
 * Wrapper on `React.lazy` to support components that are not exported by default.
 * @param factory The factory returning the componont
 */
export function lazyComponent<T extends () => Promise<React.ComponentType<any>>>(factory: T) {
  return lazy(() => factory().then(component => ({ default: component })));
}

/**
 * Convert svg to Material Ui SvgIcon.
 * @param reactSvgComponent The Svg Icon
 */
export function asSvgIcon(reactSvgComponent: (p: object) => JSX.Element) {
  const Icon = forwardRef<any, any>(function (props, ref) {
    const viewBox = useMemo(() => reactSvgComponent({}).props.attr.viewBox, []);
    return <SvgIcon ref={ref} component={reactSvgComponent} viewBox={viewBox} {...props} />;
  });

  Object.defineProperty(Icon, 'displayName', {
    value: `AsSvgIcon(${(reactSvgComponent as any).displayName || reactSvgComponent.name})`,
  });

  return Icon as typeof SvgIcon;
}

/**
 * Generate styles for the given color.
 * @param theme The current theme
 * @param color The color to get
 */
export function generateChipColor(theme: Theme, color: object) {
  return {
    color: theme.palette.getContrastText(color[700]),
    backgroundColor: color[700],
  };
}
